function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import { useCallback, useState } from 'react';
export default function useMap(defaultValue) {
  var keyMapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };

  var _useState = useState(new Map(defaultValue.map(function (val) {
    return [keyMapper(val), val];
  }))),
      _useState2 = _slicedToArray(_useState, 2),
      map = _useState2[0],
      setMap = _useState2[1];

  var has = function has(value) {
    return map.has(keyMapper(value));
  };

  var add = function add(value) {
    map.set(keyMapper(value), value);
    setMap(new Map(map));
  };

  var remove = function remove(value) {
    map.delete(keyMapper(value));
    setMap(new Map(map));
  };

  var toggle = function toggle(value) {
    if (has(value)) remove(value);else add(value);
  };

  var clear = function clear() {
    return map.clear();
  };

  var replace = useCallback(function (values) {
    setMap(new Map(values ? values.map(function (val) {
      return [keyMapper(val), val];
    }) : null));
  }, [setMap, keyMapper]);
  return {
    map: map,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    replace: replace
  };
}